import http from '../utils/http.js'

export function pageQuery(data){
    // {
    //     "city": "",
    //     "creditCode": "",
    //     "name": ""
    //   }
    return http.post(`/industrialMap/pageTypeQuery/${data.page}/${data.size}`, data)
}

export function pageQueryDirectories(data){
    return http.post(`/industrialMap/pageQuery/${data.page}/${data.size}`, data)
}

export function add(data){
    return http.post(`/industrialMap/add`, data)
}
export function update(data){
    return http.put(`/industrialMap/update`, data)
}
export function del(ids){
    return http.delete(`/industrialMap/del`, ids)
}
export function mapStatistical(data){
    return http.post(`/industrialMap/statistical`, data)
}
